import { gql } from "@apollo/client";

export const productComplinaceintialState = {
  marketName: "",
  address: "",
  contactPerson: "",
  contactNumber: "",
  contractStart: "",
  contractEnd: "",
  agentId: "",
  completeWithin: "",
  products: [
    {
      productId: "",
      quantity: "",
      productCategory: "",
      productIdStatus: "",
      quantityStatus: "",
      productCategoryStatus: "",
    },
  ],

  marketNameStatus: "unchecked",
  addressStatus: "unchecked",
  contactPersonStatus: "unchecked",
  contactNumberStatus: "unchecked",
  contractStartStatus: "unchecked",
  contractEndStatus: "unchecked",
  agentIdStatus: "unchecked",

  completeWithinStatus: "unchecked",
};

export const productComplianceStatemanage = (state, action) => {
  const inputName = action?.name;
  const value = action?.value;

  const index = action?.index;
  const field = action?.field;
  const currentaction = action?.action;

  if (currentaction) {
    if (currentaction === "add") {
      const updatedproducts = [...state.products];
      updatedproducts.push({
        productId: "",
        quantity: "",
        productCategory: "",

        productIdStatus: "",
        quantityStatus: "",
        productCategoryStatus: "",
      });

      return {
        ...state,
        products: updatedproducts,
      };
    } else {
      const updatedproducts = [...state.products];
      updatedproducts.splice(index, 1);

      return {
        ...state,
        products: updatedproducts,
      };
    }

    return;
  }

  switch (inputName) {
    case "marketName": {
      const alphaNLenghthRegex = new RegExp("^.{1,30000}$");
      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          marketName: value,
          marketNameStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          marketName: "",
          marketNameStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          marketName: value,
          marketNameStatus: "error",
        };
      }
    }
    case "contactPerson": {
      const alphaNLenghthRegex = new RegExp("^.{1,300}$");

      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          contactPerson: value,
          contactPersonStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          contactPerson: "",
          contactPersonStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          contactPerson: value,
          contactPersonStatus: "error",
        };
      }
    }
    case "contactNumber": {
      const numberOnly = value.replace(/[^\d]/g, "");
      const isValidLength = numberOnly.length >= 8 && numberOnly.length <= 15;

      if (!value) {
        return {
          ...state,
          contactNumber: "",
          contactNumberStatus: "unchecked",
        };
      }

      return {
        ...state,
        contactNumber: value,
        contactNumberStatus: isValidLength ? "success" : "error",
      };
    }

    case "agentId": {
      if (value) {
        return {
          ...state,
          agentId: value,
          agentIdStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          agentId: "",
          agentIdStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          agentId: value,
          agentIdStatus: "error",
        };
      }
    }
    case "address": {
      const alphaNLenghthRegex = new RegExp("^[a-zA-Z0-9.,\\-\\s]{1,500000}$");

      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          address: value,
          addressStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          address: "",
          addressStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          address: value,
          addressStatus: "error",
        };
      }
    }

    case "contractStart": {
      const isValidDate = (dateStr) => {
        const date = new Date(dateStr);
        return !isNaN(date.getTime());
      };

      const isBeforeEnd = (startDateStr, endDateStr) => {
        const start = new Date(startDateStr);
        const end = new Date(endDateStr);
        return start < end;
      };

      if (!value) {
        return {
          ...state,
          contractStart: "",
          contractStartStatus: "unchecked",
        };
      } else if (isValidDate(value)) {
        // Check contractEnd if it exists
        let updatedContractEndStatus = state.contractEndStatus;

        if (state.contractEnd && isValidDate(state.contractEnd)) {
          updatedContractEndStatus = isBeforeEnd(value, state.contractEnd)
            ? "success"
            : "error";
        }

        return {
          ...state,
          contractStart: value,
          contractStartStatus: "success",
          contractEndStatus: updatedContractEndStatus,
        };
      } else {
        return {
          ...state,
          contractStart: value,
          contractStartStatus: "error",
        };
      }
    }

    case "contractEnd": {
      const isValidDate = (dateStr) => {
        const date = new Date(dateStr);
        return !isNaN(date.getTime());
      };

      const isAfterStart = (endDateStr, startDateStr) => {
        const end = new Date(endDateStr);
        const start = new Date(startDateStr);
        return end > start;
      };

      if (!value) {
        return {
          ...state,
          contractEnd: "",
          contractEndStatus: "unchecked",
        };
      } else if (
        isValidDate(value) &&
        isValidDate(state.contractStart) &&
        isAfterStart(value, state.contractStart)
      ) {
        return {
          ...state,
          contractEnd: value,
          contractEndStatus: "success",
        };
      } else {
        return {
          ...state,
          contractEnd: value,
          contractEndStatus: "error",
        };
      }
    }

    case "completeWithin": {
      if (!value) {
        return {
          ...state,
          completeWithin: "",
          completeWithinStatus: "unchecked",
        };
      } else if (value) {
        return {
          ...state,
          completeWithin: value,
          completeWithinStatus: "success",
        };
      }
    }

    case "products": {
      const updatedproducts = state.products.map((product) => ({ ...product }));
      if (field && index >= 0) {
        if (!updatedproducts[index]) {
          updatedproducts[index] = {
            productId: "",
            quantity: "",
            productCategory: "",
            productIdStatus: "",
            quantityStatus: "",
            productCategoryStatus: "",
          };
        }

        if (field === "productId") {
          updatedproducts[index]["productCategory"] = value?.category;
          updatedproducts[index]["productCategoryStatus"] = "success";
        }
        updatedproducts[index][field] = value;
        updatedproducts[index][field + "Status"] = "success";

        return {
          ...state,
          products: updatedproducts,
        };
      }
    }
    default:
      return state;
  }
};

export const productFilterintialState = {
  startDate: null,
  endDate: null,
  agentId: "",
};

export const productFilterStateManage = (state, action) => {
  const { name, value } = action;

  switch (name) {
    case "startDate":
      return {
        ...state,
        startDate: value,
      };

    case "endDate":
      return {
        ...state,
        endDate: value,
      };

    case "agentId":
      return {
        ...state,
        agentId: value,
      };

    case "reset":
      return productFilterintialState;

    default:
      return state;
  }
};

export const newallMallEntries = gql`
  query GetAllMallEntries(
    $page: Int
    $pageSize: Int
    $agentId: Int
    $search: String
    $startDate: Date
    $endDate: Date
  ) {
    allMallEntries(
      page: $page
      pageSize: $pageSize
      agentId: $agentId
      search: $search
      startDate: $startDate
      endDate: $endDate
    ) {
      success
      error
      message
      totalCount
      currentPage
      totalPages
      hasNextPage
      hasPreviousPage
      data {
        id
        marketName
        address
        contactPerson
        contactNumber
        contractStart
        contractEnd
        completeWithin
        agent {
          id
          employeeCode
          employeeName
        }
        createdAt
        updatedAt
        role {
          id
          role
        }
      }
    }
  }
`;

export const mallEntriesByAgent = gql`
  query GetMallEntriesByAgent(
    $agentId: Int!
    $page: Int
    $pageSize: Int
    $search: String
  ) {
    mallEntriesByAgent(
      agentId: $agentId
      page: $page
      pageSize: $pageSize
      search: $search
    ) {
      success
      message
      totalCount
      currentPage
      totalPages
      hasNextPage
      hasPreviousPage
      data {
        id
        marketName
        address
        contactPerson
        contactNumber
        contractStart
        contractEnd
        completeWithin
        createdAt
      }
    }
  }
`;

export const agreedProductsByMallId = gql`
  query GetAgreedProductsByMall($mallId: ID!) {
    agreedProductsByMallId(mallId: $mallId) {
      success
      message
      data {
        id
        productCategory
        quantity
        createdAt
        updatedAt
        product {
          id
          productCode
          productName
          productBrand
          productCategory
        }
        mallEntry {
          id
          marketName
        }
        reconciliation {
          actualQuantity
          batchExpiry
          retailPrice
          imageBefore
          imageAfter
          status
        }
        remark {
          id
          text
          approvedStatus
        }
      }
    }
  }
`;

export const mallEntryById = gql`
  query GetMallEntryById($id: Int!) {
    mallEntryById(id: $id) {
      id
      marketName
      address
      contactPerson
      contactNumber
      contractStart
      contractEnd
      completeWithin
      createdAt
      updatedAt
      agreedProducts {
        quantity
        product {
          id
          productName
          productCode
          productCategory
        }
      }
      agent {
        id
        employeeCode
        employeeName
      }
      role {
        id
        role
      }
    }
  }
`;

export const UpdateRemarkStatus = gql`
  mutation UpdateRemarkStatus($input: UpdateRemarkStatusInput!) {
    UpdateRemarkStatus(input: $input) {
      success
      message
    }
  }
`;
